import { render, staticRenderFns } from "./CalculatorDeliveries.vue?vue&type=template&id=560c91ba&"
import script from "./CalculatorDeliveries.vue?vue&type=script&lang=ts&"
export * from "./CalculatorDeliveries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports